module.exports = __webpack_public_path__ + "static/media/wbnb2b_domain_brand_B2B_Italy.844de8fa.svg";